/* eslint-disable import/no-relative-packages */

import { setUnAuthorisedEventService } from '../src/app/request/services/unauthorised-event.service';
import { setHistoryService } from '../src/app/routing/services/history.service';
import { setAllowedActionsService } from '../src/app/shared/services/allowed-actions.service';
import { setToasterService } from '../src/app/toaster/toaster.service';

const SERVICE_SETTER_MAP: { [key: string]: unknown } = {
  TOASTER_SERVICE: setToasterService,
  UNAUTHORISED_EVENT_SERVICE: setUnAuthorisedEventService,
  ALLOWED_ACTIONS: setAllowedActionsService,
  HISTORY_SERVICE: setHistoryService
};

export function setHermesUIServices(services: { [key: string]: object }) {
  Object.entries(services).forEach(([key, service]) => {
    (SERVICE_SETTER_MAP[key] as (service: object) => void)(service);
  });
}
